// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e2c16a95","239":"1a1018e6","732":"50285dda"}[chunkId] + ".chunk.js";
};